import React, { useEffect, useState } from "react";
import { Bell, X, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { adminApi } from "../../lib/api";

export const NotificationsBell = () => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const data = await adminApi.listNotifications();
      setItems(data);
    } finally { setLoading(false); }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 30000); // poll every 30s
    return () => clearInterval(t);
  }, []);

  const unread = items.filter((n) => !n.read).length;

  const markRead = async (id) => {
    await adminApi.markNotificationRead(id);
    setItems((arr) => arr.map((n) => (n.id === id ? { ...n, read: true } : n)));
  };
  const markAll = async () => {
    await adminApi.markAllNotificationsRead();
    setItems((arr) => arr.map((n) => ({ ...n, read: true })));
  };

  return (
    <div className="relative" data-testid="admin-notifications">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="relative h-9 w-9 rounded-md hover:bg-[#edf2f4] flex items-center justify-center"
        aria-label="Notifications"
        data-testid="notifications-toggle"
      >
        <Bell size={18} className="text-[#3f4b52]" />
        {unread > 0 && (
          <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#dc2626] text-white text-xs font-bold flex items-center justify-center" data-testid="notifications-badge">
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </button>

      {open && (
        <div className="absolute right-0 top-11 w-[360px] max-w-[92vw] bg-white border border-[#cfd7db] rounded-md shadow-2xl z-50">
          <div className="px-4 py-3 border-b border-[#eef2f4] flex items-center justify-between">
            <div className="font-display uppercase tracking-widest text-xs text-[#3f4b52]">Notifications</div>
            <div className="flex items-center gap-2">
              {unread > 0 && (
                <button onClick={markAll} className="text-xs text-[#f28a16] hover:underline">Mark all read</button>
              )}
              <button onClick={() => setOpen(false)} className="text-[#9aa6ad] hover:text-[#111619]"><X size={16} /></button>
            </div>
          </div>
          <div className="max-h-[460px] overflow-y-auto">
            {loading && <div className="p-4 text-sm text-[#3f4b52]">Loading…</div>}
            {!loading && items.length === 0 && <div className="p-6 text-sm text-[#3f4b52] text-center">All caught up.</div>}
            <ul className="divide-y divide-[#eef2f4]">
              {items.map((n) => (
                <li key={n.id} className={`p-3 flex items-start gap-3 ${n.read ? "opacity-70" : "bg-[#fff7ed]"}`} data-testid={`notif-${n.id}`}>
                  <div className="h-2 w-2 mt-2 rounded-full" style={{ background: n.read ? "#cfd7db" : "#f28a16" }} />
                  <div className="flex-1 min-w-0">
                    {n.job_id ? (
                      <Link to={`/admin/jobs/${n.job_id}`} className="font-semibold text-sm text-[#111619] hover:text-[#f28a16] line-clamp-2" onClick={() => markRead(n.id)}>
                        {n.title}
                      </Link>
                    ) : n.type === "stock_request" ? (
                      <Link to="/admin/stock" className="font-semibold text-sm text-[#111619] hover:text-[#f28a16] line-clamp-2" onClick={() => markRead(n.id)}>
                        {n.title}
                      </Link>
                    ) : (
                      <div className="font-semibold text-sm text-[#111619]">{n.title}</div>
                    )}
                    <div className="text-xs text-[#3f4b52] mt-0.5">{n.body}</div>
                    <div className="text-xs text-[#9aa6ad] mt-1">{new Date(n.created_at).toLocaleString("en-ZA")}</div>
                  </div>
                  {!n.read && (
                    <button
                      onClick={() => markRead(n.id)}
                      className="text-[#3f4b52] hover:text-[#10b981] h-7 w-7 rounded-md hover:bg-[#edf2f4] flex items-center justify-center"
                      title="Mark read"
                    >
                      <Check size={14} />
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationsBell;
